import { DataPoint } from "@suse-o11y/data-point";
import { z } from "zod";

import type { Metric } from "~/models/metric";

interface RawInstantVector {
	metric: Metric;

	/**
	 * Should be mutable Array to prevent from passing the resulting value back to {@link InstantVector.fromUnix}.
	 */
	value: Array<string | number>;
}

function fromUnix({ value, metric }: RawInstantVector): InstantVector {
	/**
	 * On practice the tuple is always in the expected shape,
	 * but to be TypeScript safe the DataPoint.fromUnix is used.
	 */
	const point = DataPoint.fromUnix(value, z.coerce.number()) ?? [0, 0];

	return { value: point, metric };
}

const InstantVector = { fromUnix };

interface InstantVector {
	readonly value: readonly [timestamp: number, value: number];
	readonly metric: Metric;
}

export { InstantVector };
